import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

const BASE_URL = `/ai`;

const AIService = {
    generateLanguageFlashcards: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/generate-flashcards-by-language`, data);
    },

    generateSubjectFlashcards: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/generate-flashcards-by-subject`, data);
    },

    generateDocumentFlashcards: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/generate-flashcards-by-document`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    generateFlashcardImage: (data: any, provider: string = 'gemini'): Promise<AxiosResponse> => {
        const endpoint = provider === 'openai' ? 'openai-generate-flashcard-image' : 'gemini-generate-flashcard-image';
        return instanceAxios.post(`${BASE_URL}/${endpoint}`, data);
    },
};

export default AIService;